<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">Distribuidoras</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        class="mr-3"
      ></b-form-input>

      <BaseButtonComponent to="/distributor/new" variant="primary-action"
        >Nova</BaseButtonComponent
      >

      <vue-json-to-csv
        block
        style="width: 10em"
        :json-data="state.listCSV"
        :separator="';'"
        class="ml-3"
      >
        <BaseButtonComponent block variant="primary-action">
          CSV
        </BaseButtonComponent>
      </vue-json-to-csv>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table :fixedColumns="false">
        <thead>
          <tr>
            <td>Cidade</td>
            <td>Estado</td>
            <td>Região</td>
            <td>Nome</td>
            <td>Sigla</td>
            <td>Código da Distribuidora</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.city }}</td>
            <td>{{ item.state }}</td>
            <td>{{ getRegionName(item.region) }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.initials }}</td>
            <td>{{ item.numberDist }}</td>

            <td style="text-align: right">
              <BaseButtonComponent
                :to="`/distributor/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import VueJsonToCsv from 'vue-json-to-csv';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'distributor-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        listCSV: [],
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    await this.getAll();
  },
  methods: {
    getTypeName(type) {
      if (type === 'dealership') {
        return 'Concessionária';
      } else if (type === 'permissionaire') {
        return 'Permissionária';
      }

      return '';
    },
    getRegionName(region) {
      if (region === 'centro_oeste') {
        return 'Centro Oeste';
      }

      return region.charAt(0).toUpperCase() + region.slice(1);
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/distributors' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };

        this.state.listCSV = this.state.list.map(item => ({
          Cidade: item.city,
          Estado: item.state,
          Região: this.getRegionName(item.region),
          Nome: item.name,
          Sigla: item.initials,
          Código_da_Distribuidora: item.numberDist,
        }));

        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/distributor/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Cooperativa excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    VueJsonToCsv,
    BaseButtonComponent,
  },
};
</script>
